<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <button type="button" class="btn-close" (click)="cancel()"></button>
</div>

<form role="form" #templateForm="ngForm">
  <div class="modal-body">
    <div nbc-alerts
         alerts-key="modalAlert"></div>
    <div class="form-group">
      <label>Name</label>
      <input type="text"
             appInputRestriction="restrictChars"
             class="form-control"
             id="name"
             name="name"
             autocomplete="off"
             [(ngModel)]="name"
             placeholder="Required"
             maxlength="60"
             required />
      <span class="control-label control-label-error" *ngIf="showErrormsg">{{errorMsg}}</span>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" id="btnCreateTemplate" (click)="cloneTemplate()" [disabled]="submitted">Clone</button>
    <button type="button" class="btn btn-default" (click)="cancel()">Cancel</button>
  </div>
</form>
